// Contact Form Handler (footer)
import { executeRecaptcha } from './recaptcha-handler.js';

$("#contact_form").submit(function (event) {

    var $form = $(this);
    event.preventDefault();

    $('.js-feedback').html('').hide();

    // Execute reCAPTCHA v3 with reusable handler
    executeRecaptcha({
        form: $form[0],
        tokenFieldId: 'g-recaptcha-response-contact',
        defaultAction: 'contact_form',
        onSuccess: function () {
            submitContactForm($form);
        },
        onError: function () {
            showContactFeedback($form.data('default_error_msg'), 'warning', true);
        }
    });
});

function submitContactForm($form) {

    var formData = $form.serialize();

    $.post($form.data('action'), formData, function( response ) {
        if(response.success==0){
            showContactFeedback(response.message, 'success', true);
        }else{
            $('#contact_form')[0].reset();
            //console.log(response.message);
            var target = $('.js-feedback');
            $(target).html('')
            $(target).append('<div>'+response.message+'</div>')
            $(target).fadeIn()
            showContactFeedback(response.message, 'warning', true);
        }
    }).fail(function(error) {
        // Los middlewares de seguridad (antispam / recaptcha) devuelven su propio
        // mensaje; si existe se muestra en lugar del error genérico.
        var message = (error.responseJSON && (error.responseJSON.error || error.responseJSON.message))
            || $form.data('default_error_msg');
        var target = $('.js-feedback');
        $(target).html('')
        $(target).fadeIn()
        $(target).append('<div>'+message+'</div>')
        setTimeout(function() {
            $(target).fadeOut()
        }, 4000)
    });
}


function showContactFeedback(message, alert_type, expires = false, errors = {}) {
    var feedback = document.querySelector('.js-feedback');
    // Reset feedback content
    feedback.innerHTML = '';

    var container = document.createElement('div');
    container.className = 'alert ' + 'alert-' + alert_type;

    // If errors
    if (Object.keys(errors).length > 0) {
        var errorUl = document.createElement('ul');
        errorUl.style.margin = 0;
        errorUl.style.paddingLeft = "20px";

        Object.values(errors).forEach(function (error, i) {
            error.forEach(function (err) {
                var errorLi = document.createElement('li');
                errorLi.innerText = err;
                errorUl.appendChild(errorLi);
            })
        });

        container.appendChild(errorUl);
    } else {
        var text = document.createElement('div');
        text.innerHTML = message;
        container.appendChild(text);
    }

    // Show feedback
    feedback.appendChild(container);

    
    if (expires) {
        console.log("hiding");
        setTimeout(function() {
            feedback.innerHTML = '';
            $('.js-feedback').hide();
        }, 6000);
    }
}
